import React from "react";

const MapChart = ({ theme }) => {
  return (
    <div className="google-map-code">
      <iframe
        src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Alam%20Sutera+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        width="100%"
        height="600"
        style={
          theme === "dark"
            ? {
                filter: "grayscale(100%) invert(92%) contrast(83%)",
                border: "0",
              }
            : { border: "0" }
        }
        allowFullScreen={true}
        aria-hidden="false"
        title="Maps"
        tabIndex="0"></iframe>
    </div>
  );
};

export default MapChart;
